import { useTranslation } from 'react-i18next';

import { Card } from './ui';

/**
 * Platform badges — visible shelf of the on-chain venues Kit Pod
 * trades on. Communicates "real, named, public exchanges" rather
 * than a black-box.
 */
interface Props {
  /** When true, skip the internal "Trading on" heading — the caller
   * is providing its own section heading to avoid duplication. */
  withoutHeading?: boolean;
}

export function PlatformBadges({ withoutHeading = false }: Props = {}) {
  const { t } = useTranslation();
  return (
    <Card variant="paper" pad="md">
      {withoutHeading ? null : (
        <div className="pb-eyebrow mb-3">{t('platforms.heading')}</div>
      )}
      <div className="space-y-2">
        <Venue
          logo={<PolymarketLogo />}
          name={t('platforms.polymarket')}
          desc={t('platforms.polymarket_desc')}
        />
        <Venue
          logo={<HyperliquidLogo />}
          name={t('platforms.hyperliquid')}
          desc={t('platforms.hyperliquid_desc')}
        />
      </div>
    </Card>
  );
}

function Venue({
  logo,
  name,
  desc,
}: {
  logo: React.ReactNode;
  name: string;
  desc: string;
}) {
  return (
    <div className="flex items-center gap-3 rounded-pb-md bg-pb-paper2 p-3">
      <div className="shrink-0">{logo}</div>
      <div className="min-w-0 flex-1">
        <div className="text-[14px] font-semibold">{name}</div>
        <div className="pb-caption mt-0.5 leading-snug">{desc}</div>
      </div>
    </div>
  );
}

function PolymarketLogo() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" aria-hidden>
      <rect width="28" height="28" rx="8" fill="#1c4ed8" />
      <path
        d="M9 9h6a4 4 0 0 1 0 8h-4v4H9V9Zm2 2v4h4a2 2 0 0 0 0-4h-4Z"
        fill="#fff"
      />
    </svg>
  );
}

function HyperliquidLogo() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" aria-hidden>
      <rect width="28" height="28" rx="8" fill="#00b3a1" />
      <path
        d="M5 14c3 0 3-4 6-4s3 8 6 8 3-6 6-6"
        stroke="#fff"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
